const moment = require("moment");

const resume = {};
resume["meta_desc"] =
  "Resume of Chetan Arya - Hands On fullstack software architect, engineering leader, manager of managers.";
resume["meta_keywords"] =
  "Chetan Arya, Fullstack, Polyglot, Software Architect";
resume["meta_base_url"] = "https://chetanarya.com";
resume["image_url"] = "http://via.placeholder.com/300/300";
resume["title"] =
  "Chetan Arya - Hands On polyglot fullstack Engineering Leader.";
resume["my_name"] = "Chetan Arya";
const headlines = [
  "Senior Engineering Leader with about 16+ years of work experience, capable of turning ideas into market ready products." ,
  "Employed with Times Internet Limited as Head Of Technology with provable service tenure of almost a decade.",
  "Have delivered highly scalable, consumer-focussed digital, distributed cloud native and on-premise platforms, android, web applications, large data science and machine learning platforms, SaaS solutions.",
  "Have created and executed technology delivery roadmaps, have done infra/ resource planning, budget management and performance management.",
  "Hired 100+ engineers/ managers/ architects/ technology leaders for the current organization across functional teams, technology stacks.",
  "Involved in projects with direct revenue/ reputation impact, resource/time/ budget constraints or cross-department/ cross-technology stack projects."
];
resume["headlines"] = headlines;

const github = { name: "Github", url: "https://github.com/chetanarya" }
resume["github"] = github
const linkedin = { name: "LinkedIn", url: "https://www.linkedin.com/in/chetanarya" }
resume["linkedin"] = linkedin
const twitter = { name: "Twitter", url: "https://twitter.com/chetanarya" }
resume["twitter"] = twitter
const contact_points = [
  github,
  linkedin,
  twitter,
  //  { name: "Email", url: "mailto:chetan@chetanarya.com" }
  //, {
  //   name: "WhatsApp",
  //   url: "whatsapp://send?text=Hello Chetan&phone=+919818483862"
  // }
];
resume["email"] = "arya.chetan@gmail.com"
resume["mobile"] = "(+91) 9818 4838 62"
resume["contact_points"] = contact_points;
//https://jsfiddle.net/9D88g/133/
//https://github.com/wycats/handlebars.js/issues/1300
const jobs = [
  {
    title: "Head of Technology at Times Internet Limited (December 2019 to present)",
    org: "Times Internet Limited/ Times Prime",
    location: "Gurgaon/ Noida",
    dates: "December, 2019 - Present",
    roles: [
      "Installed correct processes and tools to convert from guess work engineering to responsible engineering.",
      "Identified (and replaced where needed), groomed, hired almost every engineer/ manager/ leader in the technology team as of today.",
      "Hands on and involved in Design, Architecture, of backend micro services, web (react based) and android applications.",
      "Responsible now for high quality, high velocity and stable technology deliveries from the engineering team.",
    ]
  },
  {
    title: "Chief Manager / Delivery Manager/ Chief Architect at Times Internet Limited",
    org: "Times Internet Limited",
    location: "Noida",
    dates: "January, 2013 - December, 2019",
    roles: [
      "Responsible for architecting and delivering large scale (>1.5m DAU) content recommendation engine.",
      "Involved in architecture, design, implementation, delivery, stakeholder management, people management, mentorship, hiring etc.",
      "Built a team of few hand picked engineers which is expected to grow 50 engineers/managers.",
      "Product utilizes Spring boot based REST API architecture and Python for the data mining/machine learning work.",
      "The end-to-end response times of the API is 99% < 150 ms.",
      "Successfully built and launched Coke (GrowthRX) in the market. Coke is a large scale data science/ analytics platform for analyzing user behaviour, user retention tracking, user targeting via push notifications, email etc. Within coke’s mandate, successfully delivered a machine learning project within coke platform that auto clustered users from segments for easy identification.Responsible from inception to delivery of Canvas maker, IDE for front end developers for improved developer efficiency/ increased speed of delivery.",
      "Coke had handled peak loads of greater than 15K events/sec.It stores about 50 TB (terabyte) data spread across several billion data points.",
      "Built and led a team of 10 engineers/ managers/ architects for Coke’s design, implementation and delivery.",
      "Saved close to 7 crores for the business in the first 8 months of going online.",
      "Won the BCCL Chairman's award for innovation and marketing spends savings.",
      "Responsible from inception to delivery of Canvas maker, IDE for front end developers for improved developer efficiency/ increased speed of delivery.",
      "Reduced operation costs by 15%, by working on infrastructure monitoring and reporting to increase resource efficiency and utilization.",
      "Supervised the site performance optimization program. Provided clear roadmap/ delivery plans across multiple teams as part of this program.This resulted in 20% site speed improvements. Received the Aspire award for the same.",
      "Introduced wordpress based quick site deployments.",
      "Worked on back-end content delivery pipelines, introduced zero downtime blue green deployments(using nginx).",
    ]
  },
  {
    title: "Architect/ Development Lead",
    org: "Barclays Technology Centre India",
    location: "Pune",
    dates: "July, 2012 to December, 2012",
    roles: [
      "Designed and implemented in a very tight deadline a business critical high throughput component.",
      "Integrated with the Solace messaging component."
    ]
  },
  {
    title: "Architect/ Track Lead",
    org: "Royal Bank of Scotland",
    location: "Gurugram/ Gurgaon",
    dates: "June, 2010 - June, 2012",
    roles: [
      "Was responsible for a 5 engineer team.",
      "Was the sole SPOC for the Internet Explorer modernization program in the entire BU.",
      "Replaced legacy systems with REST based backend services.",
      "Created solution for aggregation of data across projects and schemas for creation of single low latency data store cache for the screens.",
      "Worked on performance enhancement for various backend and front end systems.",
    ]
  },
  {
    title: "Technical Lead",
    org: "hCentive India Pvt. Ltd./ Wealthworkx (formed by the founders/ former employees of GlobalLogic India Pvt. Ltd.)",
    location: "Noida",
    dates: "January, 2010–June, 2010",
    roles: [
      "Designed and built the scalable system that supported concurrent access and search by 300 users with ease.",
      "Developed the core module responsible for taking in user preferences and suggesting the best policies and their premiums."
    ]
  },
  {
    title: "Technical Lead",
    org: "GlobalLogic",
    location: "Noida",
    dates: "June, 2006 - December, 2010",
    roles: [
      "Framework design, implementation (coding) and improvement.",
      "Client interaction for requirement gathering and clarification.",
      "Ramping up resources for the project.",
      "Build and Deployment Process Creation and implementation.",
    ]
  }
];

resume["jobs"] = jobs;
const languageSkills = [
  "Java",
  "Python",
  "Node.js",
];
resume["languageSkills"] = languageSkills;

const backendSkills = [
  "Spring Framework (Web, Security, Boot)",
  "Apache Kafka",
  "Flask",
];
resume["backendSkills"] = backendSkills;

const dbskills = [
  "MySQL/ MariaDB",
  "MongoDB",
  "Redis",
  "SQLite",
];
resume["dbskills"] = dbskills;
const frontendSkills = [
  "HTML5",
  "CSS3",
  "Javascript",
  "React",
  "Webpage performance optimization across delivery mechanisms",
];
resume["frontendSkills"] = frontendSkills;
// const mobileDevSkills = ["Android", "Ionic Framework", "React Native",];
// resume["mobileDevSkills"] = mobileDevSkills;
const miscSkills = [
  "Elastic",
  "Kibana",
  "Apache Spark",
  "Apache Flink",
  "Infrastructure setup",
  "Application/ Infra security",
  "Maven",
  "sbt",
  "Gradle",
  "Anaconda (Python)",
];
resume["miscSkills"] = miscSkills;
const awards = [
  "2017 BCCL Chairman's award winner.",
  "Winner of multiple Aspire awards at Times Internet Limited.",
  "Winner of the “Quarterly Appreciation” award at the Royal Bank of Scotland.",
  "Winner of the “GlobalLogic Annual Excellence” and “GlobalLogic Quarterly Excellence” Awards.",
  "Winner of two “Trainers of the Quarter” Award for training conducted at GlobalLogic.",
  "Winner of the TCS Gold Medal for the best Annual Final Year Project in 2006 for the project-'Voice Based Authentication'.",
  "Winner of the Certificate of Merit and Scholarship by Uttar Pradesh Government for being among the top 1% of the successful candidates in Mathematics and Chemistry in Class 12th. "
];

resume["awards"] = awards;


const education = [
  "Bachelor Of Technology in Computer Science from Motilal Nehru National Institute Of Technology (2002-2006) with CGPA of 9.21.",
];

resume["education"] = education;




const studies = [
  {
    content:
      'Completed Bachelor of Technology from Motial Nehru National Institute Of Technology <a href="http://www.mnnit.ac.in/" target="_blank" rel="noopener">(MNNIT) </a> majoring in Computer Science in 2002-2006.'
  }
];
resume["studies"] = studies;

const projects = [
  {
    name: "ca-mini.css",
    url: "https://github.com/chetanarya/ca-mini.css",
    desc:
      'I used <a href=https://github.com/Chalarangelo/mini.css target="_blank" rel="noopener"> mini.cs </a>for a personal project that required me to strip out all excess css from the final build for improving the site performance. Hence, forked and created a flavor for self use with build steps added.',
    tech: "CSS3, Flexbox"
  }
];
resume["projects"] = projects;
resume["techSkills"] = [
  "Java, Spring framework, JPA/ Hibernate, Apache Kafka.",
  "AWS Cloud.",
  "Elastic (Elastic Search), Mongodb, Redis, MySQL.",
  "Node.js, React, Typescript.",
  "Apache Spark, Python, PySpark, Jupyter Lab.",
  "Kibana, Docker, Kubernetes etc.",
]


const now = moment(new Date());
const year = now.year();
const lastBuildTime = now.format("MMMM Do YYYY at h:mm:ss a");
// let copyright = `&copy; Chetan Arya 2018`;
// if (year > 2018) {
//   copyright += `to ${year}.`;
// }
const copyright = `This is a work in progress. The data on this page was last updated on January 20th 2023. This page was last generated on ${lastBuildTime}</p>`;

resume["copyright"] = copyright;

//export { resume };
module.exports = resume;



// WEBPACK FOOTER //
// ./content/resume-json/resume-data.js